import styled from "styled-components";
import { Avatar } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { withStyles } from "@mui/styles";

import { theme } from "../../config/theme";

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: theme.palette.common.white,
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "0",
    color: "rgba(0,0,0,.6)"
  },
  body: {
    fontSize: `13px`,
    border: "0px solid white"
  }
}))(TableCell);

const StyledTableRow = withStyles(() => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: `${theme.palette.action.hover} `
    }
  }
}))(TableRow);

const ActionCell = styled(StyledTableCell)`
  padding: "3px 0 0 0";
`;

const UserCell = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .name {
    font-size: 14px;
    font-weight: 500;
  }

  .email {
    color: #5c6784;
    font-weight: 300;
  }
`;

const StyledAvatar = styled(Avatar)`
  font-size: 12px;
  margin-right: 10px;
  background: ${(props) => props.bgcolor};
`;

export { StyledTableCell, StyledTableRow, ActionCell, UserCell, StyledAvatar };
